/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
var moduleClassNameFactory_1 = require("../util/moduleClassNameFactory");
var propertyToMCSSstate_1 = require("../util/propertyToMCSSstate");
var IconButton_1 = require("../IconButton");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./NavigationHeader.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-page-top");
var NavigationHeader = /** @class */ (function (_super) {
    tslib_1.__extends(NavigationHeader, _super);
    function NavigationHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavigationHeader.prototype.render = function () {
        var _a = this.props, children = _a.children, _b = _a.positioning, positioning = _b === void 0 ? "fixed" : _b, _c = _a.light, light = _c === void 0 ? false : _c, _d = _a.dark, dark = _d === void 0 ? false : _d;
        var className = classnames(moduleClassName(), this.props.className, propertyToMCSSstate_1.propertyToMCSSstate(moduleClassName(), positioning), light && moduleClassName("isLight"), dark && moduleClassName("isDark"));
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: moduleClassName("inner") }, children)));
    };
    NavigationHeader.propTypes = {
        light: PropTypes.bool,
        dark: PropTypes.bool,
        positioning: PropTypes.oneOf(["fixed", "absolute", "relative"])
    };
    NavigationHeader.defaultProps = {
        light: false,
        positioning: "fixed"
    };
    return NavigationHeader;
}(React.Component));
exports.NavigationHeader = NavigationHeader;
exports.NavigationHeaderIconButton = function NavigationHeaderIconButton(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (React.createElement(IconButton_1.IconButton, tslib_1.__assign({ className: classnames(moduleClassName("iconButton"), className) }, props)));
};
exports.NavigationHeaderIconButton.propTypes = IconButton_1.IconButton.propTypes;
exports.NavigationHeaderIconButton.defaultProps = IconButton_1.IconButton.defaultProps;
exports.NavigationHeaderContent = function NavigationHeaderContent(_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: classnames(moduleClassName("content"), className) }, children));
};